export default "assets/images/logo-black-341f743a.png";